import React from "react";
import { Toggle as SharedToggle } from "../../../../../../../../shared/Toggle/Toggle";
import styles from "./styles.module.scss";
import { useContext } from "../../../../context";

export const Toggle = ({ blockFieldType, children, afterChange }) => {
  const { blocks } = useContext();
  const focusedBlock = blocks.getCurrent();

  return (
    <SharedToggle
      className={styles.root}
      labelClassName={styles.label}
      isEnabled={focusedBlock[blockFieldType] || false}
      onChange={() => {
        blocks.update(
          focusedBlock.id,
          blockFieldType,
          !focusedBlock[blockFieldType],
        );
        afterChange?.();
      }}
    >
      {children}
    </SharedToggle>
  );
};
